import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { SalesDocMatchingQueueContainerModel } from '../../../../../models/aggregates/e-invoice/bl_fi_einvoice_sales_doc_matching_queue_container.model';
@Injectable({
  providedIn: 'root'
})
export class SalesDocMatchingQueueService extends BaseApiTemplateService<SalesDocMatchingQueueContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/sales-doc-matching-queues/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/sales-doc-matching-queues/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/sales-doc-matching-queues/backoffice-ep'
    this.httpClient = http;
  }
}
